import vs from './ValidationService';
import i18next from 'i18next';

class GlobalValidator {
    static validateAuthentication(params) {
        let error = {};
        let errorUsername = vs.isName(params.username, true);
        if (errorUsername) {
            error.username = errorUsername;
        }
        let errorPassword = vs.isPassword(params.password, true);
        if (errorPassword) {
            error.password = errorPassword;
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }

    static validateRegistration(params) {
        let error = {};
        let errorUsername = vs.isName(params.username, true);
        if (errorUsername) {
            error.username = errorUsername;
        }
        let errorPassword = vs.isPassword(params.password, true);
        if (errorPassword) {
            error.password = errorPassword;
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }

    static validateJoinClub(params) {
        let error = {};
        let errorClubId = vs.isNumeric(params.clubId, true);

        if (errorClubId) {
            error.clubId = errorClubId;
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }

    static validateCreateClub(params) {
        let error = {};
        let errorUsername = vs.isUserName(params.username, true);
        if (errorUsername) {
            error.username = errorUsername;
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }

    static validateBalanceTransfer(params) {
        let error = {};
        if (!params.source) {
            error.selectedPlayer = i18next.t('error.selectedPlayer');
        }
        if (!params.destination) {
            error.selectedPlayer = i18next.t('error.selectedPlayer');
        }

        let errorAmount = vs.isAmount(params.amount, true);
        if (errorAmount) {
            error.amount = errorAmount;
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }

    static validateUpdateClubAccount(params) {
        let error = {};
        let errorEmail = vs.isEmail(params.email);
        if (errorEmail) {
            error.email = errorEmail;
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }

    static validateChangePassword(params) {
        let error = {};
        let errorCurrentPassword = vs.isRequired(params.currentPassword, true);
        if (errorCurrentPassword) {
            error.currentPassword = i18next.t('error.currentPassword');;
        }

        let errorNewPassword = vs.isPassword(params.newPassword, 'newPassword', true);
        if (errorNewPassword) {
            error.newPassword = errorNewPassword;
        }

        let errorRepeatPassword = vs.isRequired(params.repeatPassword);
        if(errorRepeatPassword) {
            error.repeatPassword =  i18next.t('error.repeatPassword');
        }
        
        if(params.currentPassword && params.newPassword === params.currentPassword){
            error.newPassword = i18next.t('error.samePasswords')
        }

        if (params.repeatPassword && params.newPassword && params.newPassword !== params.repeatPassword) {
            error.repeatPassword = i18next.t('error.passwordsMismatch');
        }

        if (params === 'default') {
            error.newPassword = '';
            error.currentPassword = '';
            error.repeatPassword = '';
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }

    static validateForgotPassword(params) {
        let error = {};
        let errorEmail = vs.isEmail(params.email);
        if (errorEmail) {
            error.email = errorEmail;
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }

    static validateResetPassword(params) {
        let error = {};
        let errorCurrentPassword = vs.isPassword(params.currentPassword, true);
        if (errorCurrentPassword) {
            error.currentPassword = errorCurrentPassword;
        }

        let errorNewPassword = vs.isPassword(params.newPassword, true);
        if (errorNewPassword) {
            error.newPassword = errorNewPassword;
        }

        if (params.newPassword !== params.repeatPassword) {
            error.repeatPassword = i18next.t('error.passwordsMismatch');
        }

        let success = Object.keys(error).length;
        return {success: !success, error: error};
    }
}

export default GlobalValidator;
